import { LocalizationPipe, PermissionService } from '@abp/ng.core';
import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { PermissionConstants } from 'src/core/constants/permission.constant';
import { HolidaySettingsComponent } from './holidays/holiday-settings.component';
import { LocalizationSettingsComponent } from './localization-settings.component';

const LocalizationTab = {
  Formats: 1,
  Language: 2,
  Holidays: 3,
} as const;

@Component({
  selector: 'app-localization-main',
  standalone: true,
  imports: [
    CommonModule,
    LocalizationPipe,
    NgbNavModule,
    LocalizationSettingsComponent,
    HolidaySettingsComponent,
  ],
  templateUrl: './localization-main.component.html',
  styleUrl: './localization-main.component.scss',
})
export class LocalizationMainComponent implements OnInit {
  private readonly permissionService = inject(PermissionService);

  readonly LocalizationTab = LocalizationTab;
  activeTab: number = LocalizationTab.Formats;

  ngOnInit(): void {
    if (!this.canManageDisplayPreferences) {
      this.activeTab = LocalizationTab.Holidays;
    }
  }

  /** Time zone, date, time, phone and number formats plus the interface language. */
  get canManageDisplayPreferences(): boolean {
    return this.permissionService.getGrantedPolicy(
      PermissionConstants.canManageLocalizationSettings
    );
  }

  get canViewHolidays(): boolean {
    return this.permissionService.getGrantedPolicy(PermissionConstants.canViewHolidayCalendar);
  }
}
